
export default {
  name: 'VsSwatchColor',
  props: {
    color: {
      type: String,
      default: 'transparent'
    }
  },
  computed: {
    transparent() {
      return this.color == 'transparent'
    }
  }
}
